import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M16,13.89a4.36,4.36,0,0,0-5.72.38,4.32,4.32,0,0,0,0,6.14l4.82,4.81a1.4,1.4,0,0,0,.87.31,1.53,1.53,0,0,0,1-.38l4.75-4.74a4.32,4.32,0,0,0,0-6.14A4.36,4.36,0,0,0,16,13.89ZM20.31,19,16,23.3,11.69,19A2.3,2.3,0,0,1,11,17.34a2.33,2.33,0,0,1,.69-1.66,2.38,2.38,0,0,1,3.33,0l1,1,1-1a2.37,2.37,0,0,1,3.33,0A2.33,2.33,0,0,1,21,17.34,2.3,2.3,0,0,1,20.31,19Z"/><path d="M27.29,11.4,17.2,1.9a2,2,0,0,0-2.4,0L4.71,11.4A2,2,0,0,0,4,12.93V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V12.93A2,2,0,0,0,27.29,11.4ZM26,28H6V12.93l0,0,0,0L16,3.52l9.92,9.34,0,0,0,0Z"/>';
export var FavoriteHomeOutlineSVG = function FavoriteHomeOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
FavoriteHomeOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FavoriteHomeOutlineSVG);